export const GET_ORDERS = 'GET_ORDERS';
export const CREATE_ORDER = 'CREATE_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const SEND_INVOICE = 'SEND_INVOICE';
export const GENERATE_INVOICE = 'GENERATE_INVOICE';
export const GET_LINK_FOR_QUOTE_IMAGE = 'GET_LINK_FOR_QUOTE_IMAGE';
export const VIEWING_AN_ORDER = 'VIEWING_AN_ORDER';
